"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
const errors_1 = require("../errors");
const getTokens = (app, code, code_verifier, authUrl = `https://auth.sportnet.online/token`) => __awaiter(void 0, void 0, void 0, function* () {
    const tokens = yield fetch(authUrl, {
        method: 'post',
        credentials: 'include',
        headers: {
            'content-type': 'application/json',
        },
        body: JSON.stringify({
            client_id: app,
            code_verifier,
            grant_type: 'authorization_code',
            code,
        }),
    }).then((response) => {
        window.localStorage.removeItem('code_verifier');
        if (response.ok) {
            return response.json();
        }
        else {
            throw new errors_1.AuthorizationCodeResponseError(response);
        }
    });
    return tokens;
});
exports.default = getTokens;
